<template>
  <div class="flex items-center gap-x-4 capitalize">
    <div
      class="whitespace-nowrap rounded-md bg-[#2185791A] px-4 py-1.5 text-sm font-medium text-[#218579]"
    >
      Asset A
    </div>
    <div
      v-if="dataStatus === 'to do'"
      class="flex items-center gap-x-1.5 font-medium text-[#0574B6]"
    >
      <DottedCircleIcon />
      <span class="whitespace-nowrap">{{ dataStatus }}</span>
    </div>
    <div
      v-if="dataStatus === 'in progress' || dataStatus === 'pending'"
      class="flex items-center gap-x-0 font-medium text-[#ED8F1C]"
    >
      <ClockIcon :custom-style="`w-8 h-8 mt-3`" />
      <span class="whitespace-nowrap">{{ dataStatus }}</span>
    </div>
    <div
      v-if="dataStatus === 'done' || dataStatus === 'approved'"
      class="flex items-center gap-x-1.5 font-medium text-[#218579]"
    >
      <CheckRoundedSmall :custom-style="`w-3.5 h-3.5 text-white`" />
      <span>{{ dataStatus }}</span>
    </div>
    <div
      v-if="dataStatus === 'rejected'"
      class="flex items-center gap-x-1.5 font-medium text-[#E96551]"
    >
      <CloseRoundedIcon :custom-style="`w-5 h-5`" />
      <span>{{ dataStatus }}</span>
    </div>
    <div class="relative w-[150px]">
      <div class="h-1.5 w-full rounded-full bg-[#F2F4F7]">
        <div
          class="h-1.5 rounded-full bg-[#218579]"
          :style="`width: 12%`"
        />
      </div>
    </div>
    <div class="text-xs font-medium">
      12%
    </div>
  </div>
</template>

<script>
export default {
  name: 'EsgDataUploadPercentageLoader',

  props: {
    totalMetric: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      dataStatus: 'to do',
    }
  },
}
</script>
